import { ITemplateSummaryDto, TemplateSummaryDto } from '@/repositories';

export class TrendTemplateSummaryConverter {
  toModel(dto: ITemplateSummaryDto): TemplateSummaryDto {
    return new TemplateSummaryDto(dto);
  }
}
